module.exports = __webpack_public_path__ + "static/media/helmet.ad6b88ad.png";